import { render, staticRenderFns } from "./RepresentativesList.vue?vue&type=template&id=20e79a06&scoped=true"
import script from "./RepresentativesList.vue?vue&type=script&lang=ts"
export * from "./RepresentativesList.vue?vue&type=script&lang=ts"
import style0 from "./RepresentativesList.vue?vue&type=style&index=0&id=20e79a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e79a06",
  null
  
)

export default component.exports